import styled from "styled-components";

const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: space-between;
  overflow-anchor: none;
  height: auto;
  position: relative;
  z-index: 2;
`

export default ConversationWrapper